module.exports = __webpack_public_path__ + "img/bg_chat.e70d700c.png";